/* ZIRA — animaciones y piezas interactivas de las secciones (Shopify) */
(() => {
  if (window.__ziraInit) return;
  window.__ziraInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const IO = 'IntersectionObserver' in window;

  /* ---------- Aparición al scrollear ---------- */
  function reveal() {
    const items = $$('.zira-root .rv:not(.in)');
    if (!items.length) return;
    if (!IO || reduce) { items.forEach(el => el.classList.add('in')); return; }
    const io = new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    items.forEach(el => io.observe(el));
  }

  /* ---------- Galería de la ficha ---------- */
  function galeria() {
    const main = $('[data-gal-main]'), thumbs = $('[data-thumbs]');
    if (!main || !thumbs || thumbs.dataset.listo) return;
    thumbs.dataset.listo = '1';
    const imgs = $$('img', main);
    thumbs.innerHTML = imgs.map((im, i) =>
      `<button class="thumb" type="button" aria-label="Ver foto ${i + 1}" aria-pressed="${i === 0}"><img src="${im.src}" alt=""></button>`).join('');
    const tb = $$('.thumb', thumbs);
    let cur = 0;
    const show = i => {
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach((im, k) => im.classList.toggle('on', k === cur));
      tb.forEach((b, k) => b.setAttribute('aria-pressed', k === cur));
    };
    tb.forEach((b, i) => b.addEventListener('click', () => show(i)));
    let x0 = null;
    main.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- Caja de compra: packs, colores y agregar al carrito ---------- */
  function compra() {
    const buy = $('[data-buy]'), form = $('[data-zira-form]');
    if (!buy || !form || buy.dataset.listo) return;
    buy.dataset.listo = '1';

    let variantes = [];
    try { variantes = JSON.parse($('[data-zira-variants]').textContent); } catch (e) {}

    const UNIDADES = { 1: 1, 2: 2 };
    let pack = 1, qty = 1;
    const colores = ['', ''];
    $$('[data-color][data-u="0"]', $('[data-card="1"]')).forEach((b, i) => { if (i === 0) colores[0] = b.dataset.color; });
    colores[1] = colores[0];

    const pintar = () => {
      const salida = $('[data-qty-out]');
      if (salida) salida.textContent = qty;
      $$('.plan-card').forEach(c => c.classList.toggle('on', +c.dataset.card === pack));
      const ahorro = $('[data-save]');
      if (ahorro) ahorro.hidden = pack === 1;
      $$('.plan-card .color-opt').forEach(b => {
        const card = b.closest('.plan-card');
        const activo = colores[+b.dataset.u] === b.dataset.color;
        b.setAttribute('aria-checked', activo);
        if (card && +card.dataset.card !== pack) b.setAttribute('aria-checked', activo);
      });
      $$('.unit').forEach(fila => {
        const mini = $('.unit-mini', fila);
        const elegido = $('.color-opt[aria-checked="true"]', fila);
        if (!mini || !elegido) return;
        const archivo = elegido.dataset.miniSrc;
        if (!archivo || mini.getAttribute('src') === archivo) return;
        mini.classList.add('cambiando');
        const listo = () => { mini.classList.remove('cambiando'); mini.removeEventListener('load', listo); };
        mini.addEventListener('load', listo);
        mini.src = archivo;
      });
    };

    $$('[data-pack]').forEach(b => b.addEventListener('click', () => { pack = +b.dataset.pack; pintar(); }));
    $$('.color-opt').forEach(b => b.addEventListener('click', () => { colores[+b.dataset.u] = b.dataset.color; pintar(); }));
    $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
      qty = Math.max(1, Math.min(10, qty + +b.dataset.qty)); pintar();
    }));
    pintar();

    const idDe = color => {
      if (!variantes.length) return null;
      const v = variantes.find(x => (x.title || '').toLowerCase().includes(color)) || variantes[0];
      return v.id;
    };

    form.addEventListener('submit', async e => {
      e.preventDefault();
      const boton = $('[data-add-main]');
      if (!variantes.length) return;
      const unidades = UNIDADES[pack];
      const items = [];
      for (let u = 0; u < unidades; u++) {
        const id = idDe(colores[u] || colores[0]);
        const ya = items.find(i => i.id === id);
        ya ? (ya.quantity += qty) : items.push({ id, quantity: qty });
      }
      boton.disabled = true;
      const textoPrevio = boton.textContent;
      boton.textContent = 'Agregando…';
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!r.ok) throw new Error('No se pudo agregar');
        window.location.href = '/cart';
      } catch (err) {
        boton.disabled = false;
        boton.textContent = textoPrevio;
        form.submit();
      }
    });
  }

  /* ---------- Simulador de serie ---------- */
  function simulador() {
    const sim = $('[data-sim]');
    if (!sim || sim.dataset.listo) return;
    sim.dataset.listo = '1';
    const reps = $('[data-reps]', sim), out = $('[data-sim-out]', sim), cnt = $('[data-sim-count]', sim);
    const bh = $('[data-bar-hand]', sim), bm = $('[data-bar-muscle]', sim);
    const mh = $('[data-m-hand]', sim), mm = $('[data-m-muscle]', sim);
    reps.innerHTML = '<i></i>'.repeat(12);
    const ds = $$('i', reps);
    let mode = 'sin', timer = null;
    const MODES = {
      sin: { stop: 8, hand: r => r * 12.5, muscle: r => r * 7.5, end: 'Repe 8: la mano soltó. <em>Al músculo le quedaban 4 más.</em>' },
      zira: { stop: 12, hand: r => r * 3.6, muscle: r => r * 8.34, end: 'Repe 12: <em>el que llegó al límite fue el músculo,</em> como tenía que ser.' }
    };
    const draw = r => {
      const m = MODES[mode];
      ds.forEach((d, i) => { d.className = i < r ? (mode === 'zira' ? 'full' : 'on') : (mode === 'sin' && r >= m.stop ? 'fail' : ''); });
      const h = Math.min(100, Math.round(m.hand(r))), mu = Math.min(100, Math.round(m.muscle(r)));
      bh.style.width = h + '%'; bm.style.width = mu + '%';
      mh.textContent = h + '%'; mm.textContent = mu + '%';
      cnt.textContent = `${r} / 12 repes`;
    };
    const run = () => {
      clearInterval(timer);
      const m = MODES[mode]; let r = 0; draw(0);
      out.textContent = mode === 'sin' ? 'Serie sin grip…' : 'Serie con ZIRA…';
      if (reduce) { draw(m.stop); out.innerHTML = m.end; return; }
      timer = setInterval(() => { draw(++r); if (r >= m.stop) { clearInterval(timer); out.innerHTML = m.end; } }, 280);
    };
    const setMode = b => { mode = b.dataset.mode; $$('[data-mode]', sim).forEach(x => x.setAttribute('aria-pressed', x === b)); run(); };
    $$('[data-mode]', sim).forEach(b => b.addEventListener('click', () => setMode(b)));
    $('[data-sim-replay]', sim).addEventListener('click', run);
    if (IO) {
      new IntersectionObserver(([en], o) => {
        if (!en.isIntersecting) return;
        o.disconnect(); run();
        if (!reduce) setTimeout(() => { if (mode === 'sin') setMode($('[data-mode="zira"]', sim)); }, 280 * 8 + 2200);
      }, { threshold: .15 }).observe(sim);
    } else run();
  }

  /* ---------- Videos: slider + visor grande ---------- */
  function videos() {
    const vids = $('[data-vids]');
    if (!vids || vids.dataset.listo) return;
    vids.dataset.listo = '1';
    const list = $$('video', vids);

    if (IO) {
      const vio = new IntersectionObserver(es => es.forEach(en => {
        if (en.isIntersecting && !reduce) en.target.play().catch(() => {});
        else en.target.pause();
      }), { threshold: .6 });
      list.forEach(v => vio.observe(v));
    }

    const bar = $('[data-vids-bar]'), prev = $('[data-vids-prev]'), next = $('[data-vids-next]');
    const paso = () => (list[0].parentElement.getBoundingClientRect().width + 10) * 2;
    const sync = () => {
      const max = vids.scrollWidth - vids.clientWidth;
      const p = max > 0 ? vids.scrollLeft / max : 0;
      const w = vids.clientWidth / vids.scrollWidth;
      if (bar) { bar.style.width = (w * 100) + '%'; bar.style.transform = `translateX(${p * (1 / w - 1) * 100}%)`; }
      if (prev) { prev.disabled = vids.scrollLeft < 4; next.disabled = vids.scrollLeft > max - 4; }
    };
    vids.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();
    prev && prev.addEventListener('click', () => vids.scrollBy({ left: -paso(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => vids.scrollBy({ left: paso(), behavior: 'smooth' }));

    // visor
    let vf = $('[data-vfull]');
    if (!vf) {
      vf = document.createElement('div');
      vf.className = 'vfull';
      vf.setAttribute('data-vfull', '');
      vf.setAttribute('role', 'dialog');
      vf.setAttribute('aria-modal', 'true');
      vf.innerHTML = `<div class="vfull-box">
        <video data-vfull-video playsinline loop></video>
        <button class="vfull-close" type="button" data-vfull-close aria-label="Cerrar video"><svg class="ico"><use href="#i-x"/></svg></button>
        <button class="vfull-nav prev" type="button" data-vfull-prev aria-label="Video anterior"><svg class="ico"><use href="#i-arrow-l"/></svg></button>
        <button class="vfull-nav next" type="button" data-vfull-next aria-label="Video siguiente"><svg class="ico"><use href="#i-arrow"/></svg></button>
        <button class="vfull-sound" type="button" data-vfull-sound aria-pressed="true"><svg class="ico"><use href="#i-sound-on"/></svg><span>Sonido</span></button>
      </div>`;
      document.querySelector('.zira-root').appendChild(vf);
    }
    const vfv = $('[data-vfull-video]', vf), vfs = $('[data-vfull-sound]', vf);
    let idx = 0;
    const cargar = i => {
      idx = (i + list.length) % list.length;
      vfv.src = list[idx].currentSrc || list[idx].src;
      vfv.muted = false;
      vfv.play().catch(() => { vfv.muted = true; vfv.play().catch(() => {}); });
      vfs.setAttribute('aria-pressed', !vfv.muted);
      $('use', vfs).setAttribute('href', vfv.muted ? '#i-sound-off' : '#i-sound-on');
    };
    const abrir = i => {
      list.forEach(v => v.pause());
      vf.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
      cargar(i);
      setTimeout(() => $('[data-vfull-close]', vf).focus(), 50);
    };
    const cerrar = () => {
      vf.classList.remove('open');
      document.documentElement.style.overflow = '';
      vfv.pause(); vfv.removeAttribute('src'); vfv.load();
    };
    list.forEach((v, i) => v.parentElement.addEventListener('click', () => abrir(i)));
    $('[data-vfull-close]', vf).addEventListener('click', cerrar);
    vf.addEventListener('click', e => { if (e.target === vf) cerrar(); });
    $('[data-vfull-prev]', vf).addEventListener('click', () => cargar(idx - 1));
    $('[data-vfull-next]', vf).addEventListener('click', () => cargar(idx + 1));
    vfs.addEventListener('click', () => {
      vfv.muted = !vfv.muted;
      vfs.setAttribute('aria-pressed', !vfv.muted);
      $('use', vfs).setAttribute('href', vfv.muted ? '#i-sound-off' : '#i-sound-on');
    });
    addEventListener('keydown', e => {
      if (!vf.classList.contains('open')) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowRight') cargar(idx + 1);
      if (e.key === 'ArrowLeft') cargar(idx - 1);
    });
  }


  /* ---------- Menú mobile ---------- */
  function menuMobile() {
    const menu = $('#zira-menu');
    if (!menu || menu.dataset.listo) return;
    menu.dataset.listo = '1';
    const abrir = () => { menu.classList.add('open'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => $('[data-close-menu]', menu).focus(), 50); };
    const cerrar = () => { menu.classList.remove('open'); document.documentElement.style.overflow = ''; };
    $$('[data-open-menu]').forEach(b => b.addEventListener('click', abrir));
    $$('[data-close-menu]').forEach(b => b.addEventListener('click', cerrar));
    $$('a', menu).forEach(a => a.addEventListener('click', cerrar));
    addEventListener('keydown', e => { if (e.key === 'Escape' && menu.classList.contains('open')) cerrar(); });
  }


  /* ---------- Encabezado fijo: cambia al scrollear ---------- */
  function encabezado() {
    const nav = $('.zira-root .nav') || $('.nav');
    if (!nav || nav.dataset.listo) return;
    nav.dataset.listo = '1';
    const alTope = () => nav.classList.toggle('flota', scrollY > 10);
    addEventListener('scroll', alTope, { passive: true });
    alTope();
  }


  /* ---------- Reseñas (conectadas al servidor propio) ---------- */
  function resenas() {
    const raiz = $('[data-rv-api]');
    if (!raiz || raiz.dataset.listo) return;
    raiz.dataset.listo = '1';

    const API = raiz.dataset.rvApi.replace(/\/+$/, '');
    const PRODUCTO = raiz.dataset.rvProducto || 'zira-grips';
    const lista = $('[data-rv-lista]', raiz);
    const btnMas = $('[data-rv-mas]', raiz);
    const selOrden = $('[data-rv-orden]', raiz);
    const tira = $('[data-rv-fotos]', raiz);
    let datos = [], visibles = 4;

    const fechaLinda = f => {
      try { return new Date(f).toLocaleDateString('es-AR', { day: 'numeric', month: 'long', year: 'numeric' }); }
      catch (e) { return ''; }
    };
    const estrellasHTML = n => '<span class="stars" aria-label="' + n + ' de 5 estrellas">' +
      Array.from({ length: 5 }, (_, i) => '<svg class="ico" style="opacity:' + (i < n ? 1 : .22) + '"><use href="#i-star"/></svg>').join('') + '</span>';
    const escapar = t => String(t ?? '').replace(/[<>&]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));

    function pintarResumen(info) {
      $('[data-rv-prom]', raiz).textContent = Number(info.promedio).toFixed(1).replace('.', ',');
      $('[data-rv-total]', raiz).textContent = info.total;
      $('[data-rv-estrellas]', raiz).innerHTML = Array.from({ length: 5 }, (_, i) =>
        '<svg class="ico" style="opacity:' + (i < Math.round(info.promedio) ? 1 : .22) + '"><use href="#i-star"/></svg>').join('');
      $('[data-rv-barras]', raiz).innerHTML = info.conteo.map(c => {
        const pct = info.total ? Math.round(c.cantidad / info.total * 100) : 0;
        return '<li><span>' + c.estrellas + ' \u2605</span><i><span style="width:' + pct + '%"></span></i><span>' + c.cantidad + '</span></li>';
      }).join('');
      const conFoto = datos.filter(r => r.foto);
      tira.hidden = !conFoto.length;
      tira.innerHTML = conFoto.map(r => '<img src="' + API + r.foto + '" alt="Foto de la reseña de ' + escapar(r.nombre) + '" loading="lazy">').join('');
    }

    function pintarLista() {
      const orden = selOrden.value;
      let items = datos.slice();
      if (orden === 'mejores') items.sort((a, b) => b.estrellas - a.estrellas);
      else if (orden === 'fotos') items = items.filter(r => r.foto);

      if (!items.length) {
        lista.innerHTML = '<li class="revs-vacio">' + (orden === 'fotos' ? 'Todavía no hay reseñas con foto.' : 'Sé la primera en dejar una reseña.') + '</li>';
        btnMas.hidden = true;
        return;
      }
      lista.innerHTML = items.slice(0, visibles).map(r => {
        const sello = r.verificada ? '<span class="rev-badge">Compra verificada</span>' : '';
        const foto = r.foto ? '<img class="rev-foto" src="' + API + r.foto + '" alt="Foto de la reseña" loading="lazy">' : '';
        return '<li class="rev-item">' +
          '<div class="rev-item-top"><span class="rev-avatar" aria-hidden="true">' + escapar(r.nombre.charAt(0).toUpperCase()) + '</span>' +
          '<span class="rev-quien">' + escapar(r.nombre) + (r.inicial ? ' ' + escapar(r.inicial) + '.' : '') + sello + '</span>' +
          '<span class="rev-fecha">' + fechaLinda(r.fecha) + '</span></div>' +
          estrellasHTML(r.estrellas) + '<p>' + escapar(r.texto) + '</p>' + foto + '</li>';
      }).join('');
      btnMas.hidden = items.length <= visibles;
    }

    async function cargar() {
      try {
        const r = await fetch(API + '/resenas?producto=' + encodeURIComponent(PRODUCTO));
        const info = await r.json();
        datos = info.resenas || [];
        pintarResumen(info);
        pintarLista();
      } catch (e) {
        lista.innerHTML = '<li class="revs-vacio">No pudimos cargar las reseñas en este momento.</li>';
      }
    }
    btnMas.addEventListener('click', () => { visibles += 4; pintarLista(); });
    selOrden.addEventListener('change', () => { visibles = 4; pintarLista(); });
    cargar();

    /* --- formulario --- */
    const modal = $('[data-rv-modal]', raiz), form = $('[data-rv-form]', raiz);
    if (!form) return;
    const pasos = $$('.rv-step', form), barras = $$('.rv-progreso i', modal);
    const btnSig = $('[data-rv-siguiente]', form), btnAtras = $('[data-rv-atras]', form);
    let paso = 1, puntaje = 0, foto = null, ultimoFoco = null;

    const mostrar = n => {
      paso = n;
      pasos.forEach(p => p.classList.toggle('on', +p.dataset.paso === n));
      barras.forEach((b, i) => b.classList.toggle('on', i < Math.min(n, 4)));
      btnAtras.hidden = (n === 1 || n === 5);
      btnSig.innerHTML = n === 4 ? 'Enviar reseña <svg class="ico"><use href="#i-check"/></svg>'
        : n === 5 ? 'Listo' : 'Siguiente <svg class="ico"><use href="#i-arrow"/></svg>';
      $('[data-error-envio]', form).style.display = 'none';
      const primero = pasos[n - 1].querySelector('textarea, input[type=text], input[type=email]');
      if (primero && n > 1 && n < 5) setTimeout(() => primero.focus(), 60);
    };
    const pintarEstrellas = () => $$('[data-estrella]', form).forEach(b => {
      b.classList.toggle('on', +b.dataset.estrella <= puntaje);
      b.setAttribute('aria-checked', +b.dataset.estrella === puntaje);
    });
    const abrir = () => { ultimoFoco = document.activeElement; modal.classList.add('open'); document.documentElement.style.overflow = 'hidden'; mostrar(1); };
    const cerrar = () => {
      modal.classList.remove('open');
      document.documentElement.style.overflow = '';
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
      if (paso === 5) { form.reset(); puntaje = 0; foto = null; pintarEstrellas(); $('[data-rv-previa]', form).hidden = true; mostrar(1); }
    };
    $$('[data-rv-abrir]', raiz).forEach(b => b.addEventListener('click', abrir));
    $('[data-rv-cerrar]', modal).addEventListener('click', cerrar);
    modal.addEventListener('click', e => { if (e.target === modal) cerrar(); });
    addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('open')) cerrar(); });

    $$('[data-estrella]', form).forEach(b => b.addEventListener('click', () => {
      puntaje = +b.dataset.estrella; pintarEstrellas();
      $('[data-error-estrellas]', form).style.display = 'none';
    }));

    const file = $('[data-rv-file]', form), previa = $('[data-rv-previa]', form), previaImg = $('[data-rv-previa-img]', form);
    file.addEventListener('change', () => {
      const f = file.files[0];
      if (!f) return;
      const lector = new FileReader();
      lector.onload = () => {
        const im = new Image();
        im.onload = () => {
          const max = 900, escala = Math.min(1, max / Math.max(im.width, im.height));
          const c = document.createElement('canvas');
          c.width = Math.round(im.width * escala); c.height = Math.round(im.height * escala);
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
          foto = c.toDataURL('image/jpeg', .72);
          previaImg.src = foto; previa.hidden = false;
        };
        im.src = lector.result;
      };
      lector.readAsDataURL(f);
    });
    $('[data-rv-quitar]', form).addEventListener('click', () => { foto = null; file.value = ''; previa.hidden = true; });

    const marcar = (campo, mal) => $('[data-campo="' + campo + '"]', form).classList.toggle('mal', mal);
    function valida(n) {
      if (n === 1) { if (!puntaje) { $('[data-error-estrellas]', form).style.display = 'block'; return false; } return true; }
      if (n === 2) { const ok = $('#rv-texto').value.trim().length >= 10; marcar('texto', !ok); return ok; }
      if (n === 3) {
        const nom = $('#rv-nombre').value.trim().length >= 2;
        const ape = $('#rv-apellido').value.trim().length >= 2;
        const mail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test($('#rv-mail').value.trim());
        marcar('nombre', !nom); marcar('apellido', !ape); marcar('email', !mail);
        return nom && ape && mail;
      }
      return true;
    }

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (paso === 5) { cerrar(); return; }
      if (!valida(paso)) return;
      if (paso < 4) { mostrar(paso + 1); return; }

      btnSig.disabled = true;
      const textoPrevio = btnSig.innerHTML;
      btnSig.textContent = 'Enviando…';
      try {
        const r = await fetch(API + '/resenas', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            producto: PRODUCTO,
            nombre: $('#rv-nombre').value.trim(),
            apellido: $('#rv-apellido').value.trim(),
            email: $('#rv-mail').value.trim(),
            estrellas: puntaje,
            texto: $('#rv-texto').value.trim(),
            web: form.querySelector('[name=web]').value,
            foto: foto
          })
        });
        if (!r.ok) throw new Error('error');
        mostrar(5);
      } catch (err) {
        $('[data-error-envio]', form).style.display = 'block';
      } finally {
        btnSig.disabled = false;
        if (paso !== 5) btnSig.innerHTML = textoPrevio;
      }
    });
    btnAtras.addEventListener('click', () => { if (paso > 1) mostrar(paso - 1); });
    $$('input, textarea', form).forEach(el => el.addEventListener('input', () => {
      const campo = el.closest('.rv-campo');
      if (campo) campo.classList.remove('mal');
    }));
  }

  /* ---------- Carrito ---------- */
  function carrito() {
    const raiz = $('[data-car]');
    if (!raiz || raiz.dataset.listo) return;
    raiz.dataset.listo = '1';

    const MINIMO = parseInt(raiz.dataset.minimo, 10) || 0;
    const CUOTAS = parseInt(raiz.dataset.cuotas, 10) || 0;

    const plata = c => '$' + (c / 100).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    function pintar(cart) {
      const sub = $('[data-car-subtotal]'), tot = $('[data-car-total]');
      if (sub) sub.textContent = plata(cart.total_price);
      if (tot) tot.textContent = plata(cart.total_price);

      const cuo = $('[data-car-cuotas]');
      if (cuo && CUOTAS > 1 && cart.total_price) {
        cuo.textContent = 'O hasta ' + CUOTAS + ' cuotas sin interés de ' + plata(Math.round(cart.total_price / CUOTAS));
      } else if (cuo) {
        cuo.textContent = '';
      }

      const barra = $('[data-car-barra]');
      if (barra && MINIMO > 0) {
        const faltan = MINIMO - cart.item_count;
        const relleno = $('[data-car-barra-fill]'), texto = $('[data-car-barra-texto]');
        relleno.style.width = Math.min(100, (cart.item_count / MINIMO) * 100) + '%';
        texto.innerHTML = faltan > 0
          ? 'Agregá <b>' + faltan + (faltan === 1 ? ' par más' : ' pares más') + '</b> y el envío te sale gratis.'
          : '<b>¡Tenés envío gratis!</b>';
      }

      // si el carrito quedo vacio, recargamos para mostrar el estado vacio
      if (cart.item_count === 0) location.reload();
    }

    async function cambiar(linea, cantidad, fila) {
      fila.style.opacity = '.45';
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: linea, quantity: cantidad })
        });
        const cart = await r.json();
        const item = cart.items[linea - 1];
        if (!item || cantidad === 0) {
          fila.remove();
          // las lineas siguientes corren un lugar
          $$('[data-linea]').forEach((el, i) => { el.dataset.linea = i + 1; });
        } else {
          $('[data-car-cant]', fila).textContent = item.quantity;
          $('[data-car-linea]', fila).textContent = plata(item.final_line_price);
        }
        pintar(cart);
        const burbuja = $('[data-cart-count]');
        if (burbuja) burbuja.textContent = cart.item_count;
      } catch (e) {
        /* si falla, dejamos el carrito como estaba */
      }
      fila.style.opacity = '';
    }

    raiz.addEventListener('click', e => {
      const fila = e.target.closest('[data-linea]');
      if (!fila) return;
      const linea = parseInt(fila.dataset.linea, 10);
      const actual = parseInt($('[data-car-cant]', fila).textContent, 10) || 1;
      if (e.target.closest('[data-car-mas]')) cambiar(linea, actual + 1, fila);
      else if (e.target.closest('[data-car-menos]')) cambiar(linea, Math.max(0, actual - 1), fila);
      else if (e.target.closest('[data-car-quitar]')) cambiar(linea, 0, fila);
    });

    /* --- calculo de envio --- */
    const btnCalc = $('[data-car-calcular]');
    if (btnCalc) {
      btnCalc.addEventListener('click', async () => {
        const cp = $('[data-car-cp]').value.trim();
        const caja = $('[data-car-envio-res]');
        caja.hidden = false;
        if (!/^[A-Za-z]?\d{4}/.test(cp)) {
          caja.innerHTML = '<p class="mal">Escribí tu código postal, por ejemplo 1425.</p>';
          return;
        }
        // Shopify exige una provincia pero el correo calcula por el código postal:
        // comprobado que la tarifa no cambia según lo que se mande acá.
        const prov = 'Buenos Aires';
        caja.innerHTML = '<p>Buscando opciones…</p>';
        btnCalc.disabled = true;
        try {
          const u = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(cp.replace(/^[A-Za-z]/, '').slice(0, 4)) +
                    '&shipping_address[country]=Argentina&shipping_address[province]=' + encodeURIComponent(prov);
          const r = await fetch(u);
          const d = await r.json();
          const tarifas = d.shipping_rates || [];
          if (!tarifas.length) {
            caja.innerHTML = '<p class="mal">No encontramos envíos para ese código postal. Revisalo o escribinos.</p>';
          } else {
            caja.innerHTML = tarifas.map(t =>
              '<div class="op"><span>' + t.name + '</span><b>' +
              (parseFloat(t.price) === 0 ? 'Gratis' : plata(Math.round(parseFloat(t.price) * 100))) +
              '</b></div>').join('');
          }
        } catch (e) {
          caja.innerHTML = '<p class="mal">No pudimos calcular el envío ahora. Probá de nuevo.</p>';
        }
        btnCalc.disabled = false;
      });
      $('[data-car-cp]').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); btnCalc.click(); } });
    }

    // estado inicial de la barra y las cuotas
    fetch('/cart.js').then(r => r.json()).then(pintar).catch(() => {});
  }

  function iniciar() {
    carrito(); reveal(); resenas(); encabezado(); menuMobile(); galeria(); compra(); simulador(); videos(); }
  iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
